import styled from 'styled-components';

export const Bold = styled.span`
  font-weight: ${props => props.theme.fontBold};
`;

export const Italic = styled.span`
  font-style: italic;
`;
